/* Run & Tell: "Send a hint" (blocks/rt-send-hint.liquid) and the hint page (sections/rt-hint-page.liquid).
   One file for both. Plain ES5-ish JS, no dependencies. Safe to load twice. */
(function () {
  'use strict';
  if (window.RtHint && window.RtHint.loaded) { window.RtHint.boot(); return; }

  var KEY = 'rt-hint-list-v1';
  var FROM_KEY = 'rt-hint-from-v1';
  var MAX = 3;
  var HANDLE = /^[a-z0-9][a-z0-9-]{0,254}$/;
  var memList = null;
  var memFrom = '';

  /* ---------- helpers ---------- */
  function fill(str, map) {
    return String(str || '').replace(/\{(\w+)\}/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; });
  }
  function readCopy(root, sel) {
    var el = root.querySelector(sel);
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }
  function sanitizeName(raw) {
    var s = String(raw == null ? '' : raw);
    try { s = s.normalize('NFC'); } catch (e) { /* old browsers */ }
    s = s.replace(/<[^>]*>?/g, ' ');
    try {
      s = s.replace(new RegExp("[^\\p{L}\\p{M} '’.-]", 'gu'), '');
    } catch (e) {
      s = s.replace(/[^A-Za-zÀ-ɏ '’.-]/g, '');
    }
    s = s.replace(/\s+/g, ' ').replace(/^[\s'’.-]+/, '').trim();
    return s.slice(0, 20).trim();
  }
  function cleanHandle(h) {
    h = String(h || '').trim().toLowerCase();
    return HANDLE.test(h) ? h : '';
  }
  function parseItems(search) {
    var out = [], seen = {}, items = '', from = '';
    try {
      var p = new URLSearchParams(search || '');
      items = p.get('items') || '';
      from = p.get('from') || '';
    } catch (e) { /* ignore */ }
    items.split(',').forEach(function (h) {
      var c = cleanHandle(h);
      if (c && !seen[c] && out.length < MAX) { seen[c] = 1; out.push(c); }
    });
    return { items: out, from: sanitizeName(from) };
  }
  function buildShareUrl(origin, path, handles, name) {
    var url = String(origin || '').replace(/\/$/, '') + (path || '/pages/hint');
    url += '?items=' + handles.map(encodeURIComponent).join(',');
    var n = sanitizeName(name);
    if (n) url += '&from=' + encodeURIComponent(n);
    return url;
  }
  function cleanList(a) {
    var seen = {}, out = [];
    if (!Array.isArray(a)) return out;
    a.forEach(function (x) {
      if (!x || typeof x !== 'object') return;
      var h = cleanHandle(x.h);
      if (!h || seen[h] || out.length >= MAX) return;
      seen[h] = 1;
      out.push({
        h: h,
        t: String(x.t || h).slice(0, 200),
        img: typeof x.img === 'string' && /^(https?:)?\/\//.test(x.img) ? x.img : ''
      });
    });
    return out;
  }
  function loadList() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (raw) return cleanList(JSON.parse(raw));
      if (memList) return memList.slice();
      return [];
    } catch (e) {
      return memList ? memList.slice() : [];
    }
  }
  function saveList(list) {
    memList = cleanList(list);
    try { window.localStorage.setItem(KEY, JSON.stringify(memList)); } catch (e) { /* private mode: memory only */ }
  }
  function loadFrom() {
    try { return sanitizeName(window.localStorage.getItem(FROM_KEY) || memFrom); } catch (e) { return memFrom; }
  }
  function saveFrom(v) {
    memFrom = sanitizeName(v);
    try { window.localStorage.setItem(FROM_KEY, memFrom); } catch (e) { /* ignore */ }
  }
  function isPhone() {
    try { return !!navigator.share && window.matchMedia('(pointer: coarse)').matches; } catch (e) { return false; }
  }
  function imgUrl(src, width) {
    if (!src) return '';
    src = String(src);
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (/^data:/.test(src)) return src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ---------- product page: button + tray ----------
     Event delegation on the block root, and every render looks its elements up again, so the
     block keeps working if the theme morphs the product section after a variant change. */
  function initButton(root) {
    if (root.__rtHint) {
      if (root.getAttribute('data-rt-hint-ready') !== '1') root.__rtHint.render();
      return;
    }
    var copy = readCopy(root, '[data-rt-hint-copy-json]');
    var me = {
      h: cleanHandle(root.getAttribute('data-handle')),
      t: root.getAttribute('data-title') || '',
      img: root.getAttribute('data-image') || ''
    };
    if (!me.h) return;
    var origin = root.getAttribute('data-origin') || window.location.origin;
    var path = root.getAttribute('data-hint-path') || '/pages/hint';
    var q = function (s) { return root.querySelector(s); };
    var swapMode = false, touched = false;

    function say(msg) {
      var live = q('[data-rt-hint-live]');
      if (!live) return;
      live.textContent = '';
      window.setTimeout(function () { live.textContent = msg; }, 30);
    }
    function fromValue() { var f = q('[data-rt-hint-from]'); return f ? f.value : ''; }
    function shareText() {
      var n = sanitizeName(fromValue());
      return n ? fill(copy.share_text_with_name, { name: n }) : copy.share_text;
    }
    function shareUrl() {
      return buildShareUrl(origin, path, loadList().map(function (x) { return x.h; }), fromValue());
    }
    function updateShare() {
      var url = shareUrl(), text = shareText(), both = text + ' ' + url;
      var urlIn = q('[data-rt-hint-url]'), sms = q('[data-rt-hint-sms]'), wa = q('[data-rt-hint-wa]'), mail = q('[data-rt-hint-mail]');
      if (urlIn) urlIn.value = url;
      if (sms) sms.href = 'sms:?&body=' + encodeURIComponent(both);
      if (wa) wa.href = 'https://wa.me/?text=' + encodeURIComponent(both);
      if (mail) mail.href = 'mailto:?subject=' + encodeURIComponent(text) + '&body=' + encodeURIComponent(text + '\n\n' + url);
      root.setAttribute('data-share-url', url);
    }
    function render() {
      var list = loadList();
      var inList = list.some(function (x) { return x.h === me.h; });
      if (inList || list.length < MAX) swapMode = false;
      var toggle = q('[data-rt-hint-toggle]'), toggleText = q('[data-rt-hint-toggle-text]');
      var tray = q('[data-rt-hint-tray]'), listEl = q('[data-rt-hint-list]'), countEl = q('[data-rt-hint-count]');
      var limitEl = q('[data-rt-hint-limit]'), cancelBtn = q('[data-rt-hint-cancel]'), emptyEl = q('[data-rt-hint-empty]');
      var shareBox = q('[data-rt-hint-sharebox]'), panel = q('[data-rt-hint-panel]'), shareBtn = q('[data-rt-hint-share]');
      var fromIn = q('[data-rt-hint-from]');
      if (!toggle || !tray || !listEl) return;
      if (fromIn && !fromIn.value && document.activeElement !== fromIn) fromIn.value = loadFrom();
      (toggleText || toggle).textContent = inList ? copy.button_added : copy.button_label;
      toggle.setAttribute('aria-pressed', inList ? 'true' : 'false');
      tray.hidden = !(list.length || touched);
      if (countEl) countEl.textContent = list.length ? '(' + fill(copy.count, { n: list.length }) + ')' : '';
      if (limitEl) limitEl.hidden = !swapMode;
      if (cancelBtn) cancelBtn.hidden = !swapMode;
      if (emptyEl) emptyEl.hidden = list.length > 0;
      if (shareBox) {
        shareBox.hidden = list.length === 0 || swapMode;
        if (shareBox.hidden && panel) { panel.hidden = true; if (shareBtn) shareBtn.setAttribute('aria-expanded', 'false'); }
      }
      listEl.textContent = '';
      list.forEach(function (x, i) {
        var li = el('li', 'rt-hint__item' + (x.h === me.h ? ' is-current' : ''));
        var thumb = el('span', 'rt-hint__thumb');
        if (x.img) {
          var im = el('img');
          im.src = x.img; im.alt = ''; im.width = 48; im.height = 48; im.loading = 'lazy'; im.decoding = 'async';
          thumb.appendChild(im);
        }
        li.appendChild(thumb);
        li.appendChild(el('span', 'rt-hint__name', x.t));
        var btn;
        if (swapMode) {
          btn = el('button', 'rt-hint__item-btn rt-hint__item-btn--swap', copy.swap);
          btn.setAttribute('aria-label', copy.swap + ': ' + x.t);
          btn.setAttribute('data-rt-hint-swap', String(i));
        } else {
          btn = el('button', 'rt-hint__item-btn', copy.remove);
          btn.setAttribute('aria-label', copy.remove + ': ' + x.t);
          btn.setAttribute('data-rt-hint-remove', x.h);
        }
        btn.type = 'button';
        li.appendChild(btn);
        listEl.appendChild(li);
      });
      updateShare();
      root.setAttribute('data-rt-hint-ready', '1');
    }
    function copied(ok) {
      say(ok ? copy.copied : copy.copy_failed);
      var c = q('[data-rt-hint-copy]'); if (c) c.setAttribute('data-copied', ok ? '1' : '0');
    }
    function onToggle() {
      var list = loadList(), idx = -1;
      list.forEach(function (x, i) { if (x.h === me.h) idx = i; });
      touched = true;
      if (idx > -1) {
        list.splice(idx, 1);
        saveList(list); render();
        say(fill(copy.msg_removed, { title: me.t }));
      } else if (list.length < MAX) {
        list.push({ h: me.h, t: me.t, img: me.img });
        saveList(list); render();
        say(fill(copy.msg_added, { title: me.t }));
      } else {
        swapMode = true; render();
        say(copy.tray_limit);
        var first = q('[data-rt-hint-swap]');
        if (first) first.focus();
      }
    }
    function onShare(btn) {
      updateShare();
      var panel = q('[data-rt-hint-panel]');
      if (panel) panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      if (isPhone()) {
        try {
          var p = navigator.share({ title: copy.share_title, text: shareText(), url: shareUrl() });
          if (p && p.catch) p.catch(function () { /* cancelled or blocked: the buttons are right there */ });
        } catch (e) { /* buttons stay as the fallback */ }
      }
    }
    function onCopy() {
      var url = shareUrl(), urlIn = q('[data-rt-hint-url]');
      var fallback = function () {
        try { urlIn.focus(); urlIn.select(); copied(document.execCommand('copy')); } catch (e) { copied(false); }
      };
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () { copied(true); }, fallback);
        } else { fallback(); }
      } catch (e) { fallback(); }
    }

    root.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('button') : null;
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-rt-hint-toggle')) { onToggle(); return; }
      if (t.hasAttribute('data-rt-hint-share')) { onShare(t); return; }
      if (t.hasAttribute('data-rt-hint-copy')) { onCopy(); return; }
      if (t.hasAttribute('data-rt-hint-cancel')) { swapMode = false; render(); var tg = q('[data-rt-hint-toggle]'); if (tg) tg.focus(); return; }
      var list = loadList();
      if (t.hasAttribute('data-rt-hint-swap')) {
        var i = parseInt(t.getAttribute('data-rt-hint-swap'), 10);
        if (!list[i]) return;
        var old = list[i].t;
        list[i] = { h: me.h, t: me.t, img: me.img };
        swapMode = false;
        saveList(list); render();
        say(fill(copy.msg_swapped, { old: old, 'new': me.t }));
        var tg2 = q('[data-rt-hint-toggle]'); if (tg2) tg2.focus();
      } else if (t.hasAttribute('data-rt-hint-remove')) {
        var h = t.getAttribute('data-rt-hint-remove'), gone = '';
        list = list.filter(function (x) { if (x.h === h) { gone = x.t; return false; } return true; });
        saveList(list); render();
        say(fill(copy.msg_removed, { title: gone }));
        var next = q('[data-rt-hint-list] button') || q('[data-rt-hint-toggle]');
        if (next) next.focus();
      }
    });
    root.addEventListener('input', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-rt-hint-from')) { saveFrom(e.target.value); updateShare(); }
    });
    root.addEventListener('focusout', function (e) {
      var f = e.target;
      if (f && f.hasAttribute && f.hasAttribute('data-rt-hint-from')) {
        var c = sanitizeName(f.value); if (c !== f.value) f.value = c; updateShare();
      }
    });
    window.addEventListener('storage', function (e) { if (!e.key || e.key === KEY) render(); });
    root.__rtHint = { render: render };
    render();
  }

  /* ---------- hint page ---------- */
  function initPage(root) {
    if (root.getAttribute('data-rt-hp-ready')) return;
    root.setAttribute('data-rt-hp-ready', 'loading');
    var copy = readCopy(root, '[data-rt-hp-copy-json]');
    var base = (root.getAttribute('data-root') || '/').replace(/\/$/, '');
    var cartUrl = root.getAttribute('data-cart-url') || (base + '/cart');
    var currency = root.getAttribute('data-currency') || 'USD';
    var locale = root.getAttribute('data-locale') || 'en';
    var q = function (s) { return root.querySelector(s); };
    var titleEl = q('[data-rt-hp-title]'), subEl = q('[data-rt-hp-sub]');
    var status = q('[data-rt-hp-status]'), missing = q('[data-rt-hp-missing]');
    var grid = q('[data-rt-hp-grid]'), empty = q('[data-rt-hp-empty]');
    var parsed = parseItems(window.location.search);
    var uid = 0;

    function money(cents) {
      var v = (Number(cents) || 0) / 100;
      try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(v); } catch (e) { return '$' + v.toFixed(2); }
    }
    if (parsed.from) {
      var full = fill(copy.page_subtitle_with_name, { name: parsed.from });
      var cut = full.indexOf('. ');
      titleEl.textContent = cut > -1 ? full.slice(0, cut + 1) : full;
      subEl.textContent = cut > -1 ? full.slice(cut + 2) : '';
      subEl.hidden = cut === -1;
    }
    function showEmpty() {
      titleEl.textContent = copy.empty_state_title;
      subEl.hidden = true;
      grid.hidden = true;
      empty.hidden = false;
      status.textContent = '';
      root.setAttribute('data-rt-hp-ready', 'empty');
    }
    if (!parsed.items.length) { showEmpty(); return; }

    function getProduct(h) {
      return fetch(base + '/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p && p.variants && p.variants.length ? p : null; })
        .catch(function () { return null; });
    }
    function optionList(p) {
      var opts = (p.options || []).map(function (o, i) {
        if (typeof o === 'string') {
          var vals = [];
          p.variants.forEach(function (v) { var x = v['option' + (i + 1)]; if (x != null && vals.indexOf(x) === -1) vals.push(x); });
          return { name: o, values: vals };
        }
        return { name: o.name, values: (o.values || []).slice() };
      });
      return opts;
    }
    function findVariant(p, chosen) {
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i], ok = true;
        for (var j = 0; j < chosen.length; j++) { if (v['option' + (j + 1)] !== chosen[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function card(p) {
      var opts = optionList(p);
      var start = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      var chosen = opts.map(function (o, i) { return start['option' + (i + 1)]; });
      var li = el('li', 'rt-hp__card');
      li.setAttribute('data-handle', p.handle);
      var url = base + '/products/' + p.handle;
      var media = el('a', 'rt-hp__media');
      media.href = url; media.tabIndex = -1; media.setAttribute('aria-hidden', 'true');
      var img = el('img');
      var src = (start.featured_image && start.featured_image.src) || p.featured_image || '';
      img.src = imgUrl(src, 600); img.alt = ''; img.width = 600; img.height = 600; img.loading = 'lazy'; img.decoding = 'async';
      if (!src) img.hidden = true;
      media.appendChild(img);
      li.appendChild(media);
      var body = el('div', 'rt-hp__body');
      var h2 = el('h2', 'rt-hp__title');
      var a = el('a', null, p.title); a.href = url;
      h2.appendChild(a); body.appendChild(h2);
      var price = el('p', 'rt-hp__price'); body.appendChild(price);
      var selects = [];
      opts.forEach(function (o, i) {
        if (o.values.length < 2) return;
        var id = 'RtHp-' + (++uid);
        var wrap = el('div', 'rt-hp__opt');
        var lab = el('label', 'rt-hp__label', o.name); lab.htmlFor = id;
        var sel = el('select', 'rt-hp__select'); sel.id = id; sel.setAttribute('data-index', String(i));
        o.values.forEach(function (val) { var op = el('option', null, val); op.value = val; if (val === chosen[i]) op.selected = true; sel.appendChild(op); });
        wrap.appendChild(lab); wrap.appendChild(sel); body.appendChild(wrap);
        selects.push(sel);
      });
      var btn = el('button', 'rt-hp__btn rt-hp__btn--primary rt-hp__add', copy.page_cta);
      btn.type = 'button';
      body.appendChild(btn);
      var msg = el('p', 'rt-hp__msg'); msg.setAttribute('role', 'status'); msg.setAttribute('aria-live', 'polite');
      body.appendChild(msg);
      var cartLink = el('a', 'rt-hp__cart', copy.view_cart); cartLink.href = cartUrl; cartLink.hidden = true;
      body.appendChild(cartLink);
      li.appendChild(body);

      var current = start;
      function sync() {
        current = findVariant(p, chosen);
        btn.setAttribute('aria-label', copy.page_cta + ': ' + p.title + (current && p.variants.length > 1 ? ', ' + current.title : ''));
        if (!current) {
          price.textContent = money(p.price);
          btn.disabled = true; btn.textContent = copy.unavailable;
        } else {
          price.textContent = '';
          var now = el('span', 'rt-hp__now', money(current.price));
          price.appendChild(now);
          if (current.compare_at_price && current.compare_at_price > current.price) {
            var was = el('s', 'rt-hp__was', money(current.compare_at_price));
            price.appendChild(document.createTextNode(' '));
            price.appendChild(was);
          }
          btn.disabled = !current.available;
          btn.textContent = current.available ? copy.page_cta : copy.sold_out;
          if (current.featured_image && current.featured_image.src) { img.src = imgUrl(current.featured_image.src, 600); img.hidden = false; }
        }
        li.setAttribute('data-variant-id', current ? String(current.id) : '');
      }
      selects.forEach(function (sel) {
        sel.addEventListener('change', function () { chosen[+sel.getAttribute('data-index')] = sel.value; msg.textContent = ''; sync(); });
      });
      btn.addEventListener('click', function () {
        if (!current || !current.available || btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        fetch(base + '/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] })
        }).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.description || j.message || copy.add_error); return j; });
        }).then(function () {
          btn.removeAttribute('aria-busy');
          btn.textContent = copy.added;
          msg.textContent = fill(copy.added_msg, { title: p.title });
          cartLink.hidden = false;
          window.setTimeout(function () { if (current && current.available) btn.textContent = copy.page_cta; }, 2500);
        }).catch(function (err) {
          btn.removeAttribute('aria-busy');
          msg.textContent = (err && err.message) || copy.add_error;
        });
      });
      sync();
      return li;
    }

    Promise.all(parsed.items.map(getProduct)).then(function (products) {
      var found = products.filter(Boolean);
      if (!found.length) {
        showEmpty();
        return;
      }
      found.forEach(function (p) { grid.appendChild(card(p)); });
      missing.hidden = found.length === parsed.items.length;
      status.textContent = found.length === 1 && copy.ready_one ? copy.ready_one : fill(copy.ready, { n: found.length });
      root.setAttribute('data-rt-hp-count', String(found.length));
      root.setAttribute('data-rt-hp-ready', 'done');
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rt-hint]'), initButton);
    Array.prototype.forEach.call(document.querySelectorAll('[data-rt-hint-page]'), initPage);
  }

  window.RtHint = {
    loaded: true,
    boot: boot,
    sanitizeName: sanitizeName,
    parseItems: parseItems,
    buildShareUrl: buildShareUrl,
    storageKey: KEY
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
  /* The theme can re-render or morph the product section (variant change). Re-check our roots. */
  try {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        Array.prototype.forEach.call(document.querySelectorAll('[data-rt-hint]'), function (r) {
          if (!r.__rtHint || r.getAttribute('data-rt-hint-ready') !== '1') initButton(r);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-rt-hint-ready'] });
  } catch (e) { /* no MutationObserver: fine */ }
})();
